import { PickingListReportLine } from './picking-list-report-line';

export interface PickingListReportWarehouse {
  holdStockAtProductLevel: boolean;
  warehouse: string;
  salesOrderLines: PickingListReportLine[];
}
